import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { url } from 'src/app/config/config';


@Injectable({
  providedIn: 'root'
})
export class UploadService {

  public url = url;
  constructor(private http:HttpClient) { }

  uploadFiles(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);
   
     return this.http.post(this.url+"fileUpload.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    })); 
  }

  uploadFilesAlbaran(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);
   
     return this.http.post(this.url+"fileUpload.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    })); 
  }

  uploadFilesPesosPitufo(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);
   
     return this.http.post(this.url+"fileUploadPesosPitufo.php",formData,{ headers:headers }).pipe(map(data=>{
      return data;
    })); 
  }

  uploadFilesPesosGirsac(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);
   
     return this.http.post(this.url+"fileUploadPesosGirsac.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    })); 
  }

  uploadFilesCamionesAlbaran(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);
   
     return this.http.post(this.url+"fileUploadCamiones.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    })); 
  }

  uploadFilesCuadernoCampo(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);
   
     return this.http.post(this.url+"fileupload/fileUploadCuaderno.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    })); 
  }

  uploadFilesgeneric(file: File , id: string, folder: string ,database: string, field: string){
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);
    //console.log(file.name);
   
     return this.http.post(this.url + "fileupload/fileUploadGeneric.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    })); 
  }

  uploadFilesgenericAWS(file: File , id: string, folder: string ,database: string, field: string){
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');
    
    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);
    //console.log(file.name);
   
     return this.http.post(this.url + "fileupload_aws/uploadFileGeneric.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    })); 
  }
}
